@file:Suppress("UNUSED_PARAMETER", "UNUSED_ANONYMOUS_PARAMETER")

package ui.device

import androidx.compose.runtime.*
import androidx.compose.ui.text.input.TextFieldValue
import io.Repository
import kotlinx.coroutines.launch
import tk.mallumo.compose.navigation.viewmodel.NavigationViewModel
import tk.mallumo.compose.navigation.viewmodel.VM
import tk.mallumo.utils.DataState
import tk.mallumo.utils.mutableDataState
import tools.printStackTraceInDebug

@VM
class DeviceListingVM : NavigationViewModel() {

    private lateinit var scopeUi: DeviceListingScope

    var state by mutableDataState<DeviceListingScope.Wrapper>()
        private set

    val searchFiled = mutableStateOf(TextFieldValue(""))

    sealed interface Action {
        //        class SaveItem(val new: Boolean, val poi: TemplateScope.WrapperPoi.Item) : Action
        companion object {

            @Composable
            fun rememberAction(vm: DeviceListingVM): (Action) -> Unit {
                return remember {
                    { act ->
//                        when (act) {
//
//                        }
                    }
                }
            }
        }
    }

    fun init(scopeUi: DeviceListingScope) {
        this.scopeUi = scopeUi
        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        reload()
    }

    fun reload() {
        scope.launch {
            runCatching {
                val data = if (scopeUi.args.showAll) Repository.api.device.listingAllByServer()
                else Repository.api.device.listing(companyId = scopeUi.args.companyId, locationId = scopeUi.args.locationId)

                state = DataState.Result(DeviceListingScope.Wrapper(data))
            }.onFailure {
                it.printStackTraceInDebug()
                state = DataState.Error(it.message!!, throwable = it)
            }
        }
    }

    override fun onRelease() {
        state.entry?.release()
        state = DataState.Idle()
    }

}
